/**
 * Event name emitted when the SDK is fully ready to use
 */
export const SDK_READY = "gwSdkReady";

/**
 * Enumeration of method return statuses
 */
export enum METHOD_STATUSES {
    /** Operation completed successfully */
    SUCCESS = "success",
    /** Operation failed with an error */
    ERROR = "error",
}

/**
 * Enumeration of error codes that can be returned by SDK methods
 */
export enum ERROR_CODES {
    /** General error occurred during operation */
    GENERAL_ERROR = "generalError",
    /** No subscribers were found for the event */
    NO_SUBSCRIBERS = "noSubscribers",
    /** Required arguments were missing or invalid */
    INSUFFICIENT_ARGS = "insufficientArgs",
    /** Operation timed out */
    TIMEOUT_ERROR = "timeoutError",
}

/**
 * Default timeout for promise-based operations in milliseconds
 */
export const PROMISE_TIMEOUT_MS = 15000;

/**
 * Enumeration of available SDK modules
 */
export enum SDK_MODULES {
    /** Authentication module for user authentication operations */
    AUTHENTICATION = "AuthenticationSdk",
    /** Common module providing shared functionality */
    COMMON = "CommonSdk",
    /** Products module for product data access */
    PRODUCTS = "ProductsSdk",
    /** Reviews module for product reviews functionality */
    REVIEWS = "ReviewsSdk",
    /** Rewards module for customer loyalty features */
    REWARDS = "RewardsSdk",
    /** Wishlists module for customer wishlist management */
    WISHLISTS = "WishlistsSdk",
    /** Cart module for shopping cart operations */
    CART = "CartSdk",
    /** Discounts module for managing promotions and discounts */
    DISCOUNTS = "DiscountsSdk",
    /** Gift Registry module for gift registry functionality */
    GIFT_REGISTRY = "GiftRegistrySdk",
}
